const MODAL_OVERLAY_TYPES = {
  light: "light",
  dark: "dark",
};

export { MODAL_OVERLAY_TYPES };
